module.exports = __webpack_public_path__ + "img/dot-001.81f03379.svg";